import { Excel } from "antd-table-saveas-excel";
import { t } from "i18next";
import dayjs from "../../../utils/dayjs";
import { languagesList } from "../../../utils/constants";

export const InterpretesExportsExcel = async interpretes => {
  const exportColumns = [
    { title: t("InterpreteDetail.lastname"), dataIndex: "lastname" },
    { title: t("InterpreteDetail.firstname"), dataIndex: "firstname" },
    { title: t("InterpreteDetail.interpreteNumber"), dataIndex: "abacusId" },
    { title: t("InterpreteDetail.interpreteNumbernLoga"), dataIndex: "nLoga" },
    { title: t("InterpreteDetail.genre"), dataIndex: "genre" },
    { title: t("InterpreteDetail.etatCivil"), dataIndex: "etatCivil" },
    { title: t("InterpreteDetail.languages"), dataIndex: "languages" },
    { title: t("InterpreteDetail.email"), dataIndex: "email" },
    { title: t("InterpreteDetail.phone"), dataIndex: "phone" },
    { title: t("InterpreteDetail.addressStart"), dataIndex: "addressStart" },
    { title: t("InterpreteDetail.nationality"), dataIndex: "nationality" },
    { title: t("InterpreteDetail.country"), dataIndex: "country" },
    { title: t("InterpreteDetail.birthday"), dataIndex: "birthday" },
    { title: t("InterpreteDetail.avs"), dataIndex: "avs" },
    {
      title: t("InterpreteDetail.contractStartDate"),
      dataIndex: "contractStartDate",
    },
    { title: t("InterpreteDetail.licence"), dataIndex: "licence" },
    {
      title: t("InterpreteDetail.expirationDateLicence"),
      dataIndex: "expirationDateLicence",
    },
    { title: t("InterpreteDetail.taxeSource"), dataIndex: "taxeSource" },
    {
      title: t("InterpreteDetail.partnerIndemnity"),
      dataIndex: "partnerIndemnity",
    },
    { title: t("InterpreteDetail.children"), dataIndex: "children" },
    { title: t("InterpreteDetail.shared"), dataIndex: "sharedFolder" },
    { title: t("InterpreteDetail.accessAuthorized"), dataIndex: "status" },
    { title: t("InterpreteDetail.comment"), dataIndex: "comment" },
    {
      title: t("InterpreteDetail.dateWeddingDivorce"),
      dataIndex: "dateWeddingDivorce",
    },
    { title: t("InterpreteDetail.trainings"), dataIndex: "formations" },
    { title: t("InterpreteDetail.diplomas"), dataIndex: "diplomas" },
    { title: t("InterpreteDetail.level"), dataIndex: "level" },
    {
      title: t("InterpreteDetail.authorisation"),
      dataIndex: "urgentListAllowed",
    },
    { title: t("InterpreteDetail.iban"), dataIndex: "iban" },
    { title: t("InterpreteDetail.bankingName"), dataIndex: "bankingName" },
    { title: t("InterpreteDetail.bankingHead"), dataIndex: "bankingHead" },
  ];

  const mutateData = () => {
    return interpretes.map(interprete => {
      const {
        info: {
          lastname,
          firstname,
          genre,
          etatCivil,
          phone,
          nationality,
          country,
          birthday,
          children,
        },
        email,
        status,

        interpreteData: {
          abacusId,
          addressStart,
          nLoga,
          languages,
          avs,
          contractStartDate,
          licence,
          expirationDateLicence,
          taxeSource,
          partnerIndemnity,
          sharedFolder,
          dateWeddingDivorce,
          formations,
          diplomas,
          level,
          urgentListAllowed,
          iban,
          bankingName,
          bankingHead,
        },
        comment,
      } = interprete;

      return {
        lastname,
        firstname,
        genre: genre ? t(`InterpreteDetail.${genre}`) : "",
        etatCivil: etatCivil,
        languages: languages
          ?.map(
            lang =>
              languagesList().find(language => language.value === lang)?.label,
          )
          .join(", "),
        email,
        phone,
        addressStart,
        nationality,
        country,
        birthday: birthday ? dayjs(birthday).format("DD/MM/YYYY") : "",
        abacusId,
        nLoga,
        avs,
        contractStartDate: contractStartDate
          ? dayjs(contractStartDate).format("DD/MM/YYYY")
          : "",
        licence,
        expirationDateLicence: expirationDateLicence
          ? dayjs(expirationDateLicence).format("DD/MM/YYYY")
          : "",
        taxeSource: taxeSource
          ? t("InterpreteDetail.yes")
          : t("InterpreteDetail.no"),
        partnerIndemnity,
        children,
        sharedFolder,
        status: t(status),
        comment,
        dateWeddingDivorce: dateWeddingDivorce
          ? dayjs(dateWeddingDivorce).format("DD/MM/YYYY")
          : "",
        formations,
        diplomas,
        level,
        urgentListAllowed: urgentListAllowed
          ? t("InterpreteDetail.yes")
          : t("InterpreteDetail.no"),
        iban,
        bankingName,
        bankingHead,
      };
    });
  };

  const excel = new Excel();
  excel
    .addSheet(t("InterpreteDetail.exportSheetTitle"))
    .addColumns(exportColumns)
    .addDataSource(mutateData())
    .saveAs(`${t("InterpreteDetail.exportFileName")}.xlsx`);
  return true;
};
